export const testimonials = [
    {
        name: "Sarah Williams",
        title: "Admin Klinik Sehat Medika",
        avatar: "https://i.pravatar.cc/150?img=1",
        testimonial:
            "Sejak pakai sistem ini, alur antrian jadi jauh lebih rapi dan nggak ribet sama sekali. Pasien jadi lebih tertib karena bisa langsung lihat nomor dan status antrian secara real-time. Staf juga nggak perlu bolak-balik jelasin antrian, jadi pelayanan terasa lebih lancar.",
    },
    {
        name: "Michael Johnson",
        title: "Staf Klinik Pratama Husada",
        avatar: "https://i.pravatar.cc/150?img=2",
        testimonial:
            "Dari awal pakai, kami hampir nggak butuh waktu lama buat adaptasi. Semua fitur jelas dan mudah dipahami, bahkan untuk staf yang jarang pakai sistem digital. Dampaknya, pelayanan jadi lebih cepat dan kerjaan sehari-hari terasa lebih ringan.",
    },
    {
        name: "Dr. Emily Carter",
        title: "Pengelola Klinik Anugerah Sehat",
        avatar: "https://i.pravatar.cc/150?img=3",
        testimonial:
            "Pasien sering bilang mereka suka karena sistem antriannya jelas dan transparan. Nggak ada lagi kebingungan soal giliran, semuanya tampil real-time. Sistemnya juga stabil dan cocok banget buat klinik yang mau mulai go digital tanpa ribet.",
    },
];
